export default __webpack_public_path__ + "static/media/reservation-form.bfd7844c.png";